import React from 'react'
import { LosseFlexShell } from '@ubo/losse-sjedel'
import type { LosseFlexShellProps, LosseFlexShellType } from '@ubo/losse-sjedel'

// Components
import ImagesDefault from './ImagesDefault'

const ImagesShell: React.FC<LosseFlexShellProps> = ({ fields, index }) => {
  const types: LosseFlexShellType = {
    default: ImagesDefault
  }

  return <LosseFlexShell types={types} fields={fields} index={index} />
}

export default ImagesShell
